import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StockCountingService } from '@stockcare-services/stock-counting-service/stock-counting.service';


@Component({
  standalone: false,
  selector: 'app-stat-tile',
  templateUrl: './stat-tile.component.html',
  styleUrls: ['./stat-tile.component.scss'],
})
export class StatTileComponent implements OnInit, OnChanges {
  @Input() headerText: string;
  @Input() countsLast: number;
  @Input() countsCurrent: number;
  @Input() footer: string;
  @Input() isLoading: boolean;
  @Input() showLast: boolean;

  constructor(
    private readonly stockCountingService: StockCountingService,
  ) {}

  ngOnInit(): void {
    this.getForms();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }

  getForms() {
   
    
  }
}
